<template>
  <b-modal
      :id="idModal"
      :title="tituloModal"
      size="lg"
      ok-title="Salvar"
      cancel-title="Cancelar"
      :ok-disabled="salvando || carregando"
      :cancel-disabled="salvando"
      no-close-on-backdrop
      @show="onShow"
      @ok.prevent="salvar"
  >
    <b-overlay :show="carregando || salvando">
      <div>
        <p class="mb-1">
          Selecione os clientes que poderão ver este produto customizado no
          catálogo. Sem nenhum cliente selecionado, o produto continua exclusivo
          apenas dos clientes marcados aqui.
        </p>
        <p class="mb-1 text-muted">
          <small>
            As colunas <strong>Vendável</strong>, <strong>Doável</strong> e
            <strong>Certificação</strong> abrem exceção: o cliente vinculado passa a
            ver este produto no catálogo daquele tipo de pedido mesmo que o produto
            não esteja marcado com a flag no cadastro.
          </small>
        </p>

        <b-input-group class="mb-1">
          <b-form-input
              v-model="busca"
              placeholder="Pesquisar por razão social, nome fantasia, CNPJ ou código..."
              @keyup.enter="pesquisar"
          />
          <b-input-group-append>
            <b-button variant="outline-danger" :disabled="carregando" @click="limparBusca">
              <feather-icon icon="TrashIcon"/>
            </b-button>
            <b-button variant="outline-primary" :disabled="carregando" @click="pesquisar">
              <feather-icon icon="SearchIcon"/>
            </b-button>
          </b-input-group-append>
        </b-input-group>

        <div class="mb-1 d-flex align-items-center justify-content-between">
          <small class="text-muted">
            {{ selecionados.length }} cliente(s) selecionado(s)
          </small>
        </div>

        <b-table
            :items="clientesExibidos"
            :fields="colunas"
            responsive
            small
            show-empty
            empty-text="Nenhum cliente encontrado"
            :tbody-tr-class="linhaClass"
        >
          <template #cell(selecionar)="data">
            <b-form-checkbox
                :checked="estaSelecionado(data.item.clienteid)"
                @change="alternar(data.item)"
            />
          </template>
          <!-- Checkbox sempre visível; marcar uma flag seleciona o cliente
               automaticamente (setFlag cuida disso). -->
          <template #cell(flagvendavel)="data">
            <b-form-checkbox
                :checked="getFlag(data.item.clienteid, 'flagvendavel')"
                @change="setFlag(data.item, 'flagvendavel', $event)"
            />
          </template>
          <template #cell(flagdoavel)="data">
            <b-form-checkbox
                :checked="getFlag(data.item.clienteid, 'flagdoavel')"
                @change="setFlag(data.item, 'flagdoavel', $event)"
            />
          </template>
          <template #cell(flagcertificacao)="data">
            <b-form-checkbox
                :checked="getFlag(data.item.clienteid, 'flagcertificacao')"
                @change="setFlag(data.item, 'flagcertificacao', $event)"
            />
          </template>
          <template #cell(clienterazaosocial)="data">
            {{ data.item.clienterazaosocial }}
            <b-badge
                v-if="data.item.__fixado"
                variant="light-success"
                class="ml-50"
            >
              Selecionado
            </b-badge>
          </template>
        </b-table>

        <div class="d-flex align-items-center justify-content-between mt-1">
          <span class="text-muted">
            Mostrando {{ clientes.length }} de {{ totalClientes }} clientes
          </span>
          <b-pagination
              v-model="paginaAtual"
              :total-rows="totalClientes"
              :per-page="porPagina"
              first-number
              last-number
              class="mb-0"
              @input="carregarClientes"
          />
        </div>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BModal,
  BOverlay,
  BTable,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BFormCheckbox,
  BPagination,
  BBadge,
} from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import SLSItemService from '@/services/SistemaDKP/SLSItem.service';
import SLSClienteService from '@/services/Cadastros/Cliente/SLSCliente.service';

export default {
  name: 'ModalVincularClientes',
  components: {
    BModal,
    BOverlay,
    BTable,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BFormCheckbox,
    BPagination,
    BBadge,
  },
  props: {
    idModal: {
      type: String,
      default: 'modal-vincular-clientes',
    },
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      itemService: new SLSItemService(),
      clienteService: new SLSClienteService(),
      carregando: false,
      salvando: false,
      busca: '',
      buscaAplicada: '',
      clientes: [],
      totalClientes: 0,
      paginaAtual: 1,
      porPagina: 10,
      // Conjunto de clienteids selecionados (persistido entre páginas/buscas).
      selecionados: [],
      // Registros completos dos clientes selecionados, pra fixá-los no topo
      // mesmo quando estão em outra página da listagem.
      selecionadosDetalhes: [],
      // Flags de exceção por cliente selecionado: { [clienteid]: {flagvendavel,...} }
      flagsPorCliente: {},
      colunas: [
        { key: 'selecionar', label: '' },
        { key: 'clienteiderp', label: 'Código' },
        { key: 'clienterazaosocial', label: 'Razão Social' },
        { key: 'clientenomefantasia', label: 'Nome Fantasia' },
        { key: 'clientecnpj', label: 'CNPJ' },
        { key: 'flagvendavel', label: 'Vendável', class: 'text-center' },
        { key: 'flagdoavel', label: 'Doável', class: 'text-center' },
        { key: 'flagcertificacao', label: 'Certificação', class: 'text-center' },
      ],
    };
  },
  computed: {
    tituloModal() {
      const desc = this.item && this.item.item_descricao ? ` — ${this.item.item_descricao}` : '';
      return `Vincular clientes${desc}`;
    },
    // Selecionados vêm primeiro (fixados no topo com badge), depois a página atual
    // sem duplicar quem já está fixado. Assim o usuário sempre vê o que já marcou.
    clientesExibidos() {
      const selSet = new Set(this.selecionados.map((id) => Number(id)));
      const fixados = this.selecionadosDetalhes
        .filter((c) => selSet.has(Number(c.clienteid)))
        .map((c) => ({ ...c, __fixado: true }));
      const idsFixados = new Set(fixados.map((c) => Number(c.clienteid)));
      const resto = this.clientes.filter((c) => !idsFixados.has(Number(c.clienteid)));
      return [...fixados, ...resto];
    },
  },
  methods: {
    async onShow() {
      this.busca = '';
      this.buscaAplicada = '';
      this.paginaAtual = 1;
      this.selecionados = [];
      this.selecionadosDetalhes = [];
      this.flagsPorCliente = {};
      await Promise.all([this.carregarVinculos(), this.carregarClientes()]);
    },
    async carregarVinculos() {
      if (!this.item || !this.item.item_id) return;
      this.carregando = true;
      try {
        const info = await this.itemService.getExclusividade(this.item.item_id);
        const vinculos = Array.isArray(info && info.vinculos) ? info.vinculos : [];
        this.selecionados = vinculos.length
          ? vinculos.map((v) => Number(v.clienteid))
          : (Array.isArray(info && info.clienteids) ? info.clienteids.map((c) => Number(c)) : []);
        // Reatribui o objeto inteiro (reatividade Vue2 com chaves dinâmicas).
        const mapa = {};
        vinculos.forEach((v) => {
          mapa[Number(v.clienteid)] = {
            flagvendavel: Number(v.flagvendavel) === 1,
            flagdoavel: Number(v.flagdoavel) === 1,
            flagcertificacao: Number(v.flagcertificacao) === 1,
          };
        });
        this.flagsPorCliente = mapa;
        await this.carregarDetalhesSelecionados();
      } catch (error) {
        this.notificarErro(error, 'Erro ao carregar clientes vinculados');
      } finally {
        this.carregando = false;
      }
    },
    // Busca os registros dos selecionados que ainda não temos em cache, pra poder
    // fixá-los no topo mesmo estando em outra página.
    async carregarDetalhesSelecionados() {
      const conhecidos = new Set(this.selecionadosDetalhes.map((c) => Number(c.clienteid)));
      const faltantes = this.selecionados.filter((id) => !conhecidos.has(Number(id)));
      if (!faltantes.length) return;
      const resultados = await Promise.all(
        faltantes.map((id) => this.clienteService.show(id).catch(() => null)),
      );
      const novos = resultados.filter((c) => c && c.clienteid != null);
      if (novos.length) {
        this.selecionadosDetalhes = [...this.selecionadosDetalhes, ...novos];
      }
    },
    async carregarClientes() {
      this.carregando = true;
      try {
        const resp = await this.clienteService.index({
          q: this.buscaAplicada || undefined,
          page: this.paginaAtual,
          perPage: this.porPagina,
          sortBy: 'clientenomefantasia',
          sortDesc: 'false',
        });
        const payload = resp && resp.data ? resp : { data: [], total: 0 };
        this.clientes = Array.isArray(payload.data) ? payload.data : [];
        this.totalClientes = Number(payload.total) || this.clientes.length;
      } catch (error) {
        this.notificarErro(error, 'Erro ao listar clientes');
      } finally {
        this.carregando = false;
      }
    },
    pesquisar() {
      this.buscaAplicada = (this.busca || '').trim();
      this.paginaAtual = 1;
      this.carregarClientes();
    },
    limparBusca() {
      this.busca = '';
      this.buscaAplicada = '';
      this.paginaAtual = 1;
      this.carregarClientes();
    },
    estaSelecionado(clienteid) {
      return this.selecionados.includes(Number(clienteid));
    },
    // Recebe o registro completo pra guardar seus detalhes e conseguir fixá-lo no topo.
    alternar(cliente) {
      const id = Number(cliente && cliente.clienteid);
      if (!Number.isInteger(id)) return;
      const idx = this.selecionados.indexOf(id);
      if (idx === -1) {
        this.selecionados.push(id);
        const conhecido = this.selecionadosDetalhes.some((c) => Number(c.clienteid) === id);
        if (!conhecido) this.selecionadosDetalhes.push({ ...cliente });
        if (!this.flagsPorCliente[id]) {
          this.flagsPorCliente = {
            ...this.flagsPorCliente,
            [id]: { flagvendavel: false, flagdoavel: false, flagcertificacao: false },
          };
        }
      } else {
        this.selecionados.splice(idx, 1);
        const { [id]: _removido, ...resto } = this.flagsPorCliente;
        this.flagsPorCliente = resto;
      }
    },
    getFlag(clienteid, flag) {
      const f = this.flagsPorCliente[Number(clienteid)];
      return !!(f && f[flag]);
    },
    // Reatribui o objeto inteiro — chaves dinâmicas não são reativas no Vue2.
    // Recebe o registro completo do cliente: marcar uma flag num cliente ainda
    // não selecionado também o seleciona (vínculo é pré-requisito da exceção).
    setFlag(cliente, flag, valor) {
      const id = Number(cliente && cliente.clienteid);
      if (!Number.isInteger(id)) return;
      if (valor && !this.estaSelecionado(id)) {
        this.alternar(cliente);
      }
      const atual = this.flagsPorCliente[id]
        || { flagvendavel: false, flagdoavel: false, flagcertificacao: false };
      this.flagsPorCliente = {
        ...this.flagsPorCliente,
        [id]: { ...atual, [flag]: !!valor },
      };
    },
    linhaClass(item) {
      return item && item.__fixado ? 'table-active' : '';
    },
    async salvar() {
      if (!this.item || !this.item.item_id) return;
      this.salvando = true;
      try {
        const vinculos = this.selecionados.map((id) => {
          const f = this.flagsPorCliente[Number(id)] || {};
          return {
            clienteid: Number(id),
            flagvendavel: f.flagvendavel ? 1 : 0,
            flagdoavel: f.flagdoavel ? 1 : 0,
            flagcertificacao: f.flagcertificacao ? 1 : 0,
          };
        });
        await this.itemService.setExclusividade(this.item.item_id, vinculos);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            text: 'Clientes vinculados salvos com sucesso',
            icon: 'CheckIcon',
            variant: 'success',
          },
        });
        this.$bvModal.hide(this.idModal);
        this.$emit('saved');
      } catch (error) {
        this.notificarErro(error, 'Erro ao salvar clientes vinculados');
      } finally {
        this.salvando = false;
      }
    },
    notificarErro(error, titulo) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: titulo,
          text: (error && error.message) || 'Tente novamente.',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      });
    },
  },
};
</script>
